import {SponsoredContentSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {
  originClick,
  TrackingPromotionCreative,
} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions, useTrackOriginClick} from '@aboutyou/tracking';
import {
  CardImageCTA,
  FONT_SIZES,
  mediaTabletAndUp,
  mobileOnlyLinaria,
  Slot,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {
  Header,
  Headline,
  SponsoredPlacementCard,
} from '../../../SponsoredPlacement/SponsoredPlacementCard';
import {
  ButtonWrapper,
  SPONSORED_HEADER_SPACING_CSS_VAR,
} from '../../../SponsoredPlacement/SponsoredPlacementHeader';
import {useAutoHideFollowBrandLabel} from './utils/useAutoHideFollowBrandLabel';

export const CategoryTeaser: React.FC<
  SponsoredContentSection & {
    className?: string;
    gridColumns: number | undefined;
    streamPosition: number;
    inlineBASPlacements?: boolean;
  }
> = ({
  className,
  gridColumns,
  streamPosition,
  inlineBASPlacements,
  ...sponsoredContent
}) => {
  const trackOriginClick = useTrackOriginClick();
  const {ref, hideFollowBrandLabel} = useAutoHideFollowBrandLabel();
  const promotionTracking = sponsoredContent.promotionTracking;

  const handleTrackOriginClick = () => {
    trackOriginClick(promotionTracking.locationId as originClick)();
  };

  const teaser = (
    <StyledTrackPromotions
      className={className}
      promotion={{
        advertisement: {
          id: promotionTracking.destination?.split('|')[1] ?? '',
          path: sponsoredContent.targetUrl.url,
          name: promotionTracking.promotionName,
          promotionId: promotionTracking.promotionId,
          locationId: promotionTracking.locationId,
          creativeName: promotionTracking.creativeName,
          creativeSlot: promotionTracking.creativeSlot,
        },
        source: TrackingPromotionCreative.BasCategoryTeaser,
      }}
      streamPosition={streamPosition}
      triggerOnce
    >
      <StyledSponsoredPlacementCard
        onClick={handleTrackOriginClick}
        hideFollowBrandLabel={hideFollowBrandLabel}
        imageRatio={inlineBASPlacements ? '3:4' : '5:4'}
        $headlineFontSize={
          sponsoredContent.headline.length > 47 ? 'px18' : 'px20'
        }
        {...sponsoredContent}
      />
    </StyledTrackPromotions>
  );

  if (inlineBASPlacements) {
    return <li ref={ref}>{teaser}</li>;
  }

  return (
    <Slot Comp="li" columns={gridColumns} position={streamPosition}>
      {teaser}
    </Slot>
  );
};

const StyledSponsoredPlacementCard = styled(SponsoredPlacementCard)<{
  $headlineFontSize: keyof typeof FONT_SIZES;
}>`
  ${mobileOnlyLinaria(`
    border-radius: 0;
    max-height: 300px;
    margin-left: 16px;
    padding-right:16px;
  `)}

  ${ButtonWrapper} {
    ${mobileOnlyLinaria(`
      width: calc(100% - 32px);
    `)}
  }

  ${Headline} {
    font-size: ${FONT_SIZES.px20};

    @media ${mediaTabletAndUp} {
      font-size: ${props => FONT_SIZES[props.$headlineFontSize]};
    }
  }

  ${Header} {
    ${SPONSORED_HEADER_SPACING_CSS_VAR}: 12px;
  }

  ${CardImageCTA} {
    ${tabletAndUpLinaria(`
      width: 100%;
    `)}
  }
`;

const StyledTrackPromotions = styled(TrackPromotions)`
  height: 100%;
  padding: 0;
`;
